import { render, staticRenderFns } from "./HubPagination.vue?vue&type=template&id=765bb4c1&scoped=true&"
import script from "./HubPagination.vue?vue&type=script&lang=js&"
export * from "./HubPagination.vue?vue&type=script&lang=js&"
import style0 from "./HubPagination.vue?vue&type=style&index=0&id=765bb4c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bb4c1",
  null
  
)

export default component.exports